import React from 'react';
import './history.css';

const HistoryPage = () => {
  const historyData = [
    { version: 'Input Sheet Ver. 3', status: 'Reports Generated', timestamp: '20/02/2024 12:11 P.M.', statusColor: '#FF4D4F' },
    { version: 'Input Sheet Ver. 2', status: 'Error Sheet Generated', timestamp: '20/02/2024 12:11 P.M.', statusColor: '#FF4D4F' },
    { version: 'Input Sheet Ver. 1', status: 'Upload Failed', timestamp: '20/02/2024 12:11 P.M.', statusColor: '#FF4D4F' },
    { version: 'Input Sheet Upload Failed', status: '', timestamp: '20/02/2024 12:11 P.M.', statusColor: '#FF4D4F', highlighted: true },
  ];

  return (
    <div className="history-container">
      <div className="history-header">
        <span className="history-back-arrow"> * </span>
        <h1 className="history-title">History</h1>
      </div>
      <div className="history-list">
        {historyData.map((item, index) => (
          <div
            key={index}
            className={`history-item ${item.highlighted ? 'history-item-highlighted' : ''}`}
          >
            <div className="history-item-details">
              <span className="history-item-version">{item.version}</span>
              {item.status && (
                <span className="history-item-status" style={{ color: item.statusColor }}>
                  {item.status}
                </span>
              )}
              <span className="history-item-timestamp">{item.timestamp}</span>
            </div>
            <div className="history-item-meta">
              <span className="history-item-icon">
                {item.highlighted ? '⬇' : '▼'}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HistoryPage;